import { FeatureFlagsStore } from '@/definitions/FeatureFlag';
import { create } from 'zustand';

export const useFeatureFlags = create<FeatureFlagsStore>()((set) => ({
  flags: {},
  setFlags: (flags) => set({ flags }),
}));
